var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalCompleteSuccessFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM16.6256 8.17739L10.1093 14.6937L7.8809 11.876C7.45267 11.3345 6.66656 11.2427 6.12507 11.671C5.58358 12.0992 5.49177 12.8853 5.92 13.4268L9.01958 17.3461C9.48346 17.9327 10.3551 17.9834 10.8839 17.4546L18.3934 9.94515C18.8815 9.457 18.8815 8.66554 18.3934 8.17739C17.9052 7.68923 17.1138 7.68923 16.6256 8.17739Z",
    fill: "#568200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCompleteSuccessFilled);
export default __webpack_public_path__ + "static/media/total-complete-success-filled.d3c4da2e9c163e76e2301e2ff84fe245.svg";
export { ForwardRef as ReactComponent };